import { connectHook } from 'app/common/components/connect-hook';
import { UsefulSnippits } from './useful-snippits';
import { useUsefulSnippits } from './useful-snippits-hook';

export default connectHook(UsefulSnippits, useUsefulSnippits);
